import { useState, useEffect } from "react";
import "./Loader.css";

function Loader({ onTerminado }) {
  const [ocultando, setOcultando] = useState(false);

  useEffect(() => {
    const _temporizador = setTimeout(() => {
      setOcultando(true);
    }, 450);

    const _temporizadorFin = setTimeout(() => {
      onTerminado();
    }, 1150);

    return () => {
      clearTimeout(_temporizador);
      clearTimeout(_temporizadorFin);
    };
  }, [onTerminado]);

  return (
    <div className={`loader-contenedor ${ocultando ? "loader-ocultando" : ""}`}>
      <div className="loader-contenido">
        <img
          src="/logo-glowroom.png"
          alt="Glowroom MVD"
          className="loader-logo"
        />
        <div className="loader-barra-contenedor">
          <div className="loader-barra"></div>
        </div>
        <p className="loader-texto">Cargando...</p>
      </div>
    </div>
  );
}

export default Loader;